import { render, staticRenderFns } from "./sqdList.vue?vue&type=template&id=660b5de8&scoped=true&"
import script from "./sqdList.vue?vue&type=script&lang=js&"
export * from "./sqdList.vue?vue&type=script&lang=js&"
import style0 from "./sqdList.vue?vue&type=style&index=0&id=660b5de8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660b5de8",
  null
  
)

export default component.exports